module.exports = __webpack_public_path__ + "img/table.31172409.png";